module.exports = __webpack_public_path__ + "img/slide11.39596cb8.png";